import {
  toastError,
  toastSuccess,
} from "../../../components/Utility/ToastUtils";
import * as PRIVACYPOLICY from "../../actions/PrivacyPolicy/PrivacyPolicy.action";

const initialState = {
  PrivacyPolicys: null,
  PrivacyPolicyObj: null,
  loading: false,
  error: null,
};

export const privacyPolicyReducer = (state = initialState, action) => {
  // console.log(action, "reduscer");
  switch (action.type) {
    case PRIVACYPOLICY.PRIVACYPOLICY_ADD:
      return {
        ...state,
        loading: true,
      };
    case PRIVACYPOLICY.PRIVACYPOLICY_ADD_SUCCESS:
      toastSuccess(action.payload);
      // console.log(action, "reducer");

      return {
        ...state,
        loading: false,
      };

    case PRIVACYPOLICY.PRIVACYPOLICY_ADD_FAIL:
      toastError(action.payload);
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PRIVACYPOLICY.GET_ALL_PRIVACYPOLICY:
      return {
        ...state,
        loading: true,
      };
    case PRIVACYPOLICY.GET_ALL_PRIVACYPOLICY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        PrivacyPolicys: action.payload.data,
      };
    case PRIVACYPOLICY.GET_ALL_PRIVACYPOLICY_FAIL:
      toastError(action.payload);
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PRIVACYPOLICY.DELETE_PRIVACYPOLICY_BY_ID:
      return {
        ...state,
        loading: true,
      };
    case PRIVACYPOLICY.DELETE_PRIVACYPOLICY_BY_ID_SUCCESS:
      toastSuccess(action.payload);
      return {
        ...state,
        loading: false,
        error: null,
      };
    case PRIVACYPOLICY.DELETE_PRIVACYPOLICY_BY_ID_FAIL:
      toastError(action.payload);
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PRIVACYPOLICY.SET_PRIVACYPOLICY_OBJ:
      return {
        ...state,
        loading: true,
      };
    case PRIVACYPOLICY.SET_PRIVACYPOLICY_OBJ_SUCCESS:
      toastSuccess(action.payload.message);
      return {
        ...state,
        PrivacyPolicyObj: action.payload.data,
        loading: false,
        error: null,
      };
    case PRIVACYPOLICY.SET_PRIVACYPOLICY_OBJ_FAIL:
      toastError(action.payload);
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case PRIVACYPOLICY.UPDATE_PRIVACYPOLICY_BY_ID:
      return {
        ...state,
        loading: true,
      };
    case PRIVACYPOLICY.UPDATE_PRIVACYPOLICY_BY_ID_SUCCESS:
      toastSuccess(action.payload.message);
      return {
        ...state,
        loading: false,
        error: null,
      };
    case PRIVACYPOLICY.UPDATE_PRIVACYPOLICY_BY_ID_FAIL:
      toastError(action.payload.data);
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
